import { Component, OnInit } from '@angular/core';
import { SubscriptionPackage } from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';

@Component({
  selector: 'kodit-izvestaj-page',
  templateUrl: './izvestaj-page.component.html',
  styleUrls: ['./izvestaj-page.component.scss'],
})
export class IzvestajPageComponent implements OnInit {
  /** Props */
  shouldDisplayMaloprodaja: boolean = true;
  shouldDisplayVeleprodaja: boolean = true;

  constructor(private _authService: AuthService) {}

  ngOnInit(): void {
   // this._loadDisplay();
  }

  private _loadDisplay() {
    this.shouldDisplayMaloprodaja = this._authService.hasPackage([
      SubscriptionPackage[SubscriptionPackage.MALOPRODAJA, SubscriptionPackage.FISKALNA_KASA],
    ]);

    this.shouldDisplayVeleprodaja = this._authService.hasPackage([
      SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
    ]);
  }
}
